import { useEffect, useState } from 'react';
import { subscribeToToasts, toast, type ToastItem } from '@/lib/toast';

/** Live view of the app-wide toast queue (`src/lib/toast.ts`), for `Toaster`. */
export function useToastQueue() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => subscribeToToasts(setToasts), []);

  return { toasts, dismiss: toast.dismiss };
}
